import React, { useState } from "react"

export const BookingMultiSelect = ({
	name,
	options,
	defaultText,
	customClass = "",
	showRequired = false,
	isRequired = false,
	disabled,
	allowEmpty = false,
	selected,
	updateFilters,
}) => {
	const [searchResults, setSearchResults] = useState([])

	function setValue(e) {
		let value = e.target.childNodes[e.target.selectedIndex].value
		console.log(searchResults)
		let newResults = [...searchResults]
		newResults.push(value)
		setSearchResults(newResults)
		updateFilters({ name: name, value: newResults })
	}

	function removeValue(element) {
		let newResults = searchResults.filter(e => e !== element)
		setSearchResults(newResults)
		updateFilters({ name: name, value: newResults })
	}
	// A default value in the destructuring will not catch null values
	// which in turn will trigger the selection of the first option
	let wrapperClass = "pootsy-input pootsy-select-box " + customClass
	isRequired && (wrapperClass += " is-required")
	let inputFinalClass = "pootsy-select " + customClass
	showRequired && (inputFinalClass += " show-required")
	selected !== "" && (inputFinalClass += " option-chosen")
	return (
		<div className={wrapperClass} style={{ height: "100%" }}>
			<select
				name={name}
				className={"pootsy-select-special"}
				value={selected}
				onChange={setValue}
				disabled={disabled}
			>
				<option value="" disabled={!allowEmpty} />
				{options.map(entry => (
					<option key={entry.value} value={entry.value} disabled={entry.disabled}>
						{entry.label}
					</option>
				))}
			</select>
			<label className="select-text-label">{defaultText}</label>
			<div className="pootsy-booking-multiselect">
				{searchResults.map(element => {
					return (
						<div
							onClick={() => removeValue(element)}
							className="pootsy-booking-multiselect-current-filters"
						>
							{element}
						</div>
					)
				})}
			</div>
		</div>
	)
}
